import videojs from 'video.js';

const videoElement = document.querySelector('#hero-video');

if (videoElement) {
    videojs(videoElement);
}
